import React, { useContext } from "react";
import ModalTour from "./ModalTour";
import { GlobalContext } from "../App";
import { GreyCallout } from "../Layout";
import { Link } from "react-router-dom";
import qs from "query-string";
import confetti from "canvas-confetti";
import * as _ from "lodash";
import { logger } from "../lib/Logger";
import { useEffect } from "react";
import { sendGtmEvent } from "../lib/utils";
import { trackConversion } from "../lib/analytics";
import { isTrialing } from "../Billing/billingHelpers";
import { HeartTwoTone } from "@ant-design/icons";
import { AffiliateLinkCopyInput } from "../AffiliateDialog";

let confettiPopped = false;
export const ThanksForUpgrading = (props = {}) => {
  const { loggedInUser } = useContext(GlobalContext);
  const { upgradedPlan } = qs.parse(window.location.search);

  // analytics
  useEffect(() => {
    if (upgradedPlan === "v3_base") {
      logger.log(`billing: base plan upgrade success!`);
      sendGtmEvent("upgrade_thanks_base_plan", {
        category: "upgrade",
        action: "upgrade_thanks_base_plan"
      });
    } else {
      logger.log(`billing: addon upgrade success ${upgradedPlan}`);
      sendGtmEvent("upgrade_thanks_addon", {
        category: "upgrade",
        action: "upgrade_thanks_addon",
        label: upgradedPlan
      });
    }
  }, []);

  // Trial-start conversion (Meta, OpenAI Ads). An existing customer changing plans also lands
  // here with ?upgradedPlan set, so gate on `trialing` to count only new trials.
  // Waits on loggedInUser — billing status is absent on first render.
  useEffect(() => {
    if (loggedInUser && isTrialing(loggedInUser)) {
      trackConversion("trial_started", { plan: upgradedPlan });
    }
  }, [loggedInUser, upgradedPlan]);

  // confetti
  if (!confettiPopped) {
    confetti();
    confettiPopped = true;
  }

  if (!loggedInUser) return null;

  return (
    <ModalTour
      containerStyle={props.containerStyle}
      currentStepId={props.currentStepId || null}
      onClose={props.onClose}
      closeTour={props.closeTour}
      visible={!_.isUndefined(props.visible) ? props.visible : true}
      tourSteps={tourControls => {
        return [
          {
            content: (
              <div>
                <h1>Thank you for upgrading</h1>
                <p>Your Followup Assistant just leveled up ✨ </p>
                <br />

                <p>Now let's get some things done!</p>
                <img
                  src="https://files-dl04onacn.vercel.app/inbox-zero.png"
                  style={{ width: "100%", margin: "50px 0px" }}
                />
                <br />
                <p>
                  <strong>Tip:</strong>{" "}
                  <Link
                    onClick={() => {
                      props.closeTour();
                    }}
                    to="/settings"
                  >
                    Add your other email addresses
                  </Link>{" "}
                  so your upgrade works everywhere.
                </p>
                <br />
                <br />
                <br />
                <br />
                <GreyCallout style={{ padding: 20 }}>
                  <p>
                    <strong>🎁 Earn your upgrade for free </strong>
                  </p>
                  <p>
                    Share this link to give $5 off to referrals. You get a $5
                    credit for anyone who upgrades. Everyone wins!
                  </p>
                  <AffiliateLinkCopyInput
                    style={{
                      textAlign: "center",
                      backgroundColor: "white",
                      marginLeft: 10,
                      marginRight: 10,
                      marginTop: 10,
                      marginBottom: 3,
                      width: "95%"
                    }}
                  />
                  <span style={{ color: "#999", fontSize: 12 }}>
                    Find this affiliate any time on your billing page.{" "}
                    <Link
                      to="https://help.followupthen.com/knowledge-base/affiliate-program/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Learn more
                    </Link>
                  </span>
                </GreyCallout>
                <div>
                  <strong>🙌 Team Members: </strong> Add them from{" "}
                  <Link onClick={() => props.closeTour()} to="/team">
                    team settings
                  </Link>
                </div>
              </div>
            ),
            buttonText: null
          }
        ];
      }}
    />
  );
};
